import styled            from 'styled-components';

import { cssFlexRow,
         themeColors,  
         themeTypos,
         Typo,
         typoAsCSS     } from 'src/providers/theme/shared';



type ButtonWithIconLookAndFeel = {
  typo: Typo;

  activeBgColor: string;
  disableBgColor: string;
  activeTextColor: string;
  disableTextColor: string;
  activeBorderColor: string;
  disableBorderColor: string;

  height: number;
  minWidth: number; 

  borderSize: number;
  borderRadius: number;

  gap: number;
  padding: number;
};

const baseButtonLookAndFeel = {
  gap: 10,
  padding: 16,
  minWidth: 24, 
  borderSize: 1,
};

const baseLightBlueOutlineButtonLookAndFeel = {
  ...baseButtonLookAndFeel,
  borderRadius: 1000,
  activeBgColor: themeColors.PrimaryWhite,
  disableBgColor: themeColors.PrimaryWhite,
  activeTextColor: themeColors.PrimaryBlack,
  disableTextColor: themeColors.SecondaryGray3,
  activeBorderColor: themeColors.LightBlue1,
  disableBorderColor: themeColors.SecondaryGray3,
}

const baseGreyOutlineButtonLookAndFeel = {
  ...baseButtonLookAndFeel,
  borderRadius: 12,
  activeBgColor: themeColors.PrimaryWhite,
  disableBgColor: themeColors.PrimaryWhite,
  activeTextColor: themeColors.PrimaryBlack,
  disableTextColor: themeColors.SecondaryGray3,
  activeBorderColor: themeColors.SecondaryGray2,
  disableBorderColor: themeColors.SecondaryGray3,
}

const h48 = {
  typo: themeTypos.GRTSKREG_W400_S14_LH16,
  height: 48,
}

const h64 = {
  typo: themeTypos.GRTSKREG_W400_S14_LH20,
  height: 64,
}

const h70 = {
  typo: themeTypos.GRTSKREG_W400_S12_LH18,
  height: 70,
}

const button_h48outlineround: ButtonWithIconLookAndFeel = {
    ...baseLightBlueOutlineButtonLookAndFeel,
    ...h48,
};

const button_h64greyoutline: ButtonWithIconLookAndFeel = {
  ...baseGreyOutlineButtonLookAndFeel,
  ...h64,
};

const button_h70greyoutline: ButtonWithIconLookAndFeel = {
  ...baseGreyOutlineButtonLookAndFeel,
  ...h70,
};

export type ButtonWithIconVariants = 'h48outlineround' | 'h64greyoutline' | 'h70greyoutline';

export const button_with_icon_variants: Map<ButtonWithIconVariants, ButtonWithIconLookAndFeel> = new Map<ButtonWithIconVariants, ButtonWithIconLookAndFeel>([
  ['h48outlineround', button_h48outlineround],
  ['h64greyoutline', button_h64greyoutline],
  ['h70greyoutline', button_h70greyoutline],
]);

export const ButtonWithIconContainer = styled.button<{
  lookAndFeel: ButtonWithIconLookAndFeel;
}>`
  width: 100%;
  height: ${(args) => args.lookAndFeel.height}px;

  padding: ${(args) => args.lookAndFeel.padding}px;

  ${cssFlexRow};
  gap: ${(args) => args.lookAndFeel.gap}px;;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  background-color: ${(args) => args.lookAndFeel.activeBgColor};
  border: ${(args) => `${args.lookAndFeel.borderSize}px solid ${args.lookAndFeel.activeBorderColor}`};

  border-radius: ${(args) => args.lookAndFeel.borderRadius ?? 0}px;
  &:disabled {
    background-color: ${(args) => args.lookAndFeel.disableBgColor};
    border: ${(args) => `${args.lookAndFeel.borderSize}px solid ${args.lookAndFeel.disableBorderColor}`};
  }

  &:disabled span {
    color: ${(args) => args.lookAndFeel.disableTextColor};
  }
`;

export const LabelContainer = styled.div<{labelPosition: 'center' | 'left' | 'right'}>`
  ${cssFlexRow};
  flex: 1;
  align-items: center;
  justify-content: ${({labelPosition}) => `${labelPosition}`};
  text-align: ${({labelPosition}) => `${labelPosition}`};
`

export const IconWrapper = styled.div<{
    lookAndFeel: ButtonWithIconLookAndFeel,
}>`
  ${cssFlexRow};
  min-width: ${(args) => args.lookAndFeel.minWidth}px;
`

export const Label = styled.span<{
  lookAndFeel: ButtonWithIconLookAndFeel,
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.typo)}
  color: ${(args) => args.lookAndFeel.activeTextColor};
`;
